import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { token } from '@atlaskit/tokens';
import EmojiAddIcon from '@atlaskit/icon/core/emoji-add';

import { ReactionsLoader } from '@confluence/reactions/entry-points/ReactionsLoader';
import { ReactionContainerType, ReactionLocation } from '@confluence/reactions';
import { getCachedPageData } from '@confluence/live-pages-utils/entry-points/getCachedPageData';
import { usePageContentId, useContentType, usePageSpaceKey } from '@confluence/page-context';
import { fg } from '@confluence/feature-gating';

const i18n = defineMessages({
	addNew: {
		id: 'object-comments.page.reactions.add.new',
		description: 'Message displayed in button to add a new reaction.',
		defaultMessage: 'Add new',
	},
	addReaction: {
		id: 'object-comments.page.reactions.add.reaction',
		description: 'Message displayed to add a reaction.',
		defaultMessage: 'Add reaction',
	},
});

export const ObjectCommentPageReactions = () => {
	const [contentId] = usePageContentId();
	const [contentType] = useContentType();
	const [spaceId] = usePageSpaceKey();
	const { formatMessage } = useIntl();

	const { subType } = getCachedPageData(contentId);

	// Used when we want to allow the user to select reactions from the summary view popup
	const customIcon = fg('confluence_page_reactions_ga_changes') ? (
		<EmojiAddIcon
			testId="emoji-add-icon"
			color={token('color.icon.subtle')}
			label={formatMessage(i18n.addReaction)}
		/>
	) : undefined;
	const reactionPickerText = fg('confluence_page_reactions_ga_changes')
		? formatMessage(i18n.addNew)
		: undefined;

	return (
		<ReactionsLoader
			contentId={contentId || ''}
			location={contentType === 'blogpost' ? ReactionLocation.BLOGPOST : ReactionLocation.PAGE}
			containerId={spaceId || ''}
			containerType={
				contentType === 'blogpost' ? ReactionContainerType.BLOGPOST : ReactionContainerType.PAGE
			}
			contentSubType={subType}
			summaryViewEnabled
			summaryViewThreshold={1}
			allowSelectFromSummaryView={fg('confluence_page_reactions_ga_changes')}
			useButtonAlignmentStyling
			summaryViewPlacement="bottom-end"
			hideNoReactionsText
			readOnly={false}
			isSubtle
			reactionPickerTriggerIcon={customIcon}
			reactionPickerTriggerText={reactionPickerText}
			useDefaultStyledContainer
			// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
			hidePlaceholder={Boolean(process.env.REACT_SSR || window.__SSR_RENDERED__)}
			noRelativeContainer={false}
			noFlexWrap={false}
			hoverableSummaryView={fg('confluence_page_reactions_ga_changes')}
			reactionPickerPlacement="bottom-end"
		/>
	);
};
